/* eslint-disable max-len */
/* eslint-disable security/detect-unsafe-regex */

import React from 'react';
import moment from 'moment';
export default function InvoicePreview({
    selectedAcademicYear,
    selectedClass,
    selectedSection,
    selectedFeeTermData,
    selectedStudentsCount
}) {
    // selectedFeeTermData might be an object with a `terms` array or already an array.
    const terms = Array.isArray(selectedFeeTermData)
        ? selectedFeeTermData
        : selectedFeeTermData?.terms || [];

    const currencyFormatter = new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
    });

    return (
        <div className="mx-auto mt-4 pb-[130px]">
            <div className="mb-6 p-3 border border-[#D0D5DD] rounded flex w-[80%] mx-auto">
                <div className="w-[40%] px-1">
                    <div className="flex mb-3">
                        <div className="min-w-[135px]">Academic Year</div>
                        <div className="font-semibold break-all">{selectedAcademicYear?.name}</div>
                    </div>

                    <div className="flex mb-3">
                        <div className="min-w-[135px]">Class</div>
                        <div className="font-semibold break-all w-[70%]">{selectedClass?.name}</div>
                    </div>
                    <div className="flex mb-3">
                        <div className="min-w-[135px]">Section</div>
                        <div className="font-semibold break-all w-[70%]">{selectedSection?.name}</div>
                    </div>
                </div>
                <div className="w-[60%] px-1">
                    <div className="flex mb-3">
                        <div className="min-w-[135px]">Fee Structure will be updated for {selectedStudentsCount} student(s)</div>
                    </div>
                </div>
            </div>
            <div className="flex justify-between items-center">
                <div className="px-1">
                    <div className="flex justify-start mb-3">
                        <p className="text-lg font-semibold text-[#000000]">Invoice Issue Summary</p>
                    </div>
                    <table className="w-full table-auto greyHeader" id="admin-table">
                        <thead className="top-0 left-0 bg-white">
                            <tr className="student-th">
                                <th className="w-[12%]"><span className="flex items-center justify-start font-semibold pl-2">Term</span></th>
                                <th className="w-[30%]"><span className="flex items-center justify-start font-semibold pl-2">Term Period</span></th>
                                <th className="w-[20%]"><span className="flex items-center justify-start font-semibold pl-2">Term Fee</span></th>
                                <th className="w-[35%]"><span className="flex items-center justify-start font-semibold pl-2">Notes</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {terms.map((term, index) => {
                                const endDate = moment(term?.end_date?.split("T")[0]);
                                const startDate = moment(term?.start_date?.split("T")[0]);
                                const isPastTerm = moment(endDate).isBefore(moment(), 'day');
                                const isOngoingTerm = moment().isBetween(startDate, endDate, 'day', '[]');
                                const isFutureTerm = moment(endDate).isSameOrAfter(moment()) && !isOngoingTerm && !isPastTerm;
                                const formattedAmount = parseFloat(term.term_amount || 0).toFixed(2);

                                return (
                                    <tr className="student-td" key={index}>
                                        <td className="w-[10%]">
                                            <span className="flex justify-start pl-2">{term.term_name || `Term ${index + 1}`}</span>
                                        </td>
                                        <td className="w-[30%]">
                                            <span className="flex justify-start pl-2">
                                                {`${startDate.format("DD MMM YYYY")} - ${endDate.format("DD MMM YYYY")}`}
                                            </span>
                                        </td>
                                        <td className="w-[30%]">
                                            <span className="flex items-center justify-start pl-2">{formattedAmount}</span>
                                        </td>
                                        <td className="w-[30%]">
                                            <span className="flex justify-start pl-2 flex-col">
                                                {isFutureTerm ? <><span className="text-blue-500">Future Term </span><span className='text-xs'>Invoice will be scheduled for generation on the term start date.</span></>
                                                    : isOngoingTerm ? <><span className="text-green-500">Ongoing Term </span><span className='text-xs'>Invoice will be generated upon updating the fee structure to students.</span></>
                                                        : isPastTerm ? <><span className="text-red-500">Past Term </span><span className='text-xs'>Not billable. Invoice will not be generated.</span></>
                                                            : <span className="text-gray-500">&nbsp;</span>}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
